import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { LAUNCH_BROWSER_TOOL_NAME } from './portal-tool.constants';

export { LAUNCH_BROWSER_TOOL_NAME };

export const LaunchBrowserActionSchema = z.enum([
  'launch',
  'list-instances',
  'list-pages',
  'list-credentials',
]);

export const LaunchBrowserInputSchema = z
  .object({
    action: LaunchBrowserActionSchema.default('launch'),
    startUrl: z.string().optional(),
    instanceId: z.string().optional(),
    credentialId: z.string().optional(),
    freshSession: z.boolean().optional(),
    nameFilter: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.action === 'list-pages' && !data.instanceId) {
      ctx.addIssue({
        code: 'custom',
        message: 'instanceId is required for list-pages action',
        path: ['instanceId'],
      });
    }
  });

export const LaunchBrowserInstanceSummarySchema = z.object({
  instanceId: z.string(),
  isRunning: z.boolean(),
});

export const LaunchBrowserPageSummarySchema = z.object({
  pageId: z.string(),
  url: z.string(),
  title: z.string(),
  isActive: z.boolean(),
});

export const LaunchBrowserCredentialSummarySchema = z.object({
  credentialId: z.string(),
  role: z.string(),
  username: z.string(),
  loginUrl: z.string().optional(),
  isDisabled: z.boolean().optional(),
});

export const LaunchBrowserDataSchema = z.object({
  instanceId: z.string().optional(),
  pageId: z.string().optional(),
  startUrl: z.string().optional(),
  navigatedUrl: z.string().optional(),
  focusedExisting: z.boolean().optional(),
  credentialInjected: z.boolean().optional(),
  instances: z.array(LaunchBrowserInstanceSummarySchema).optional(),
  pages: z.array(LaunchBrowserPageSummarySchema).optional(),
  credentials: z.array(LaunchBrowserCredentialSummarySchema).optional(),
});

export const LaunchBrowserOutputSchema = createPortalToolOutputSchema({
  dataSchema: LaunchBrowserDataSchema,
});

export type LaunchBrowserInput = z.infer<typeof LaunchBrowserInputSchema>;
export type LaunchBrowserOutput = z.infer<typeof LaunchBrowserOutputSchema>;
export type LaunchBrowserData = z.infer<typeof LaunchBrowserDataSchema>;
